//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './WatchlistsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type WatchlistsGetWatchlistsQueryParameters = {
  id: string ;
}

export type WatchlistsUpdateWatchlistsQueryParameters = {
  id: string ;
}

export type WatchlistsDeleteWatchlistsQueryParameters = {
  id: string ;
}

export type WatchlistsSortWatchlistsQueryParameters = {
  watchlistId: string ;
}

export type WatchlistsCreateSectionWatchlistsQueryParameters = {
  id: string ;
}

export type WatchlistsUpdateSectionWatchlistsQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type WatchlistsDeleteSectionWatchlistsQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type WatchlistsSortSectionWatchlistsQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type WatchlistsMoveAssetWatchlistsQueryParameters = {
  id: string ;
}

export type WatchlistsGetSectionLookupWatchlistsQueryParameters = {
  watchlistIds?: string[] | undefined ;
}

export type WatchlistsAddAssetWatchlistsQueryParameters = {
  id: string ;
  sectionId: string ;
}

export type WatchlistsUpdateAssetWatchlistsQueryParameters = {
  id: string ;
  sectionId: string ;
  assetId: string ;
}

export type WatchlistsDeleteAssetWatchlistsQueryParameters = {
  id: string ;
  sectionId: string ;
  assetId: string ;
}

export function watchlistsGetListUrl(): string {
  let url_ = getBaseUrl() + "/api/watchlists";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let watchlistsGetListDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, unknown, Types.ListResultDtoOfLookupDtoOfGuid>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, unknown, Types.ListResultDtoOfLookupDtoOfGuid>, 'queryFn'>> = {
};
export function getWatchlistsGetListDefaultOptions() {
  return watchlistsGetListDefaultOptions;
};
export function setWatchlistsGetListDefaultOptions(options: typeof watchlistsGetListDefaultOptions) {
  watchlistsGetListDefaultOptions = options;
}

export function watchlistsGetListQueryKey(): QueryKey;
export function watchlistsGetListQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsGetList',
    ]);
}
export function __watchlistsGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.watchlistsGetList(
axiosConfig    );
}

/**
 * @return OK
 */
export function useWatchlistsGetListQuery<TSelectData = Types.ListResultDtoOfLookupDtoOfGuid, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useWatchlistsGetListQuery<TSelectData = Types.ListResultDtoOfLookupDtoOfGuid, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __watchlistsGetList(context, axiosConfig) : __watchlistsGetList,
    queryKey: watchlistsGetListQueryKey(),
    ...watchlistsGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfLookupDtoOfGuid, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setWatchlistsGetListData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfLookupDtoOfGuid | undefined) => Types.ListResultDtoOfLookupDtoOfGuid, ) {
  queryClient.setQueryData(watchlistsGetListQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setWatchlistsGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfLookupDtoOfGuid | undefined) => Types.ListResultDtoOfLookupDtoOfGuid) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function watchlistsCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/watchlists";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsCreate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, Types.WatchlistCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, Types.WatchlistCreateDto, TContext> {
  const key = watchlistsCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.WatchlistCreateDto) => Client.watchlistsCreate(body),
    mutationKey: key,
  });
}
  
export function watchlistsGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let watchlistsGetDefaultOptions: Omit<UseQueryOptions<Types.WatchlistDto, unknown, Types.WatchlistDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.WatchlistDto, unknown, Types.WatchlistDto>, 'queryFn'>> = {
};
export function getWatchlistsGetDefaultOptions() {
  return watchlistsGetDefaultOptions;
};
export function setWatchlistsGetDefaultOptions(options: typeof watchlistsGetDefaultOptions) {
  watchlistsGetDefaultOptions = options;
}

export function watchlistsGetQueryKey(id: string): QueryKey;
export function watchlistsGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as WatchlistsGetWatchlistsQueryParameters;

    return trimArrayEnd([
        'WatchlistsClient',
        'watchlistsGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'WatchlistsClient',
        'watchlistsGet',
        ...params
      ]);
  }
}
export function __watchlistsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.watchlistsGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function useWatchlistsGetQuery<TSelectData = Types.WatchlistDto, TError = unknown>(dto: WatchlistsGetWatchlistsQueryParameters, options?: Omit<UseQueryOptions<Types.WatchlistDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useWatchlistsGetQuery<TSelectData = Types.WatchlistDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.WatchlistDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useWatchlistsGetQuery<TSelectData = Types.WatchlistDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.WatchlistDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as WatchlistsGetWatchlistsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.WatchlistDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __watchlistsGet(context, axiosConfig) : __watchlistsGet,
    queryKey: watchlistsGetQueryKey(id),
    ...watchlistsGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.WatchlistDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setWatchlistsGetData(queryClient: QueryClient, updater: (data: Types.WatchlistDto | undefined) => Types.WatchlistDto, id: string) {
  queryClient.setQueryData(watchlistsGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setWatchlistsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.WatchlistDto | undefined) => Types.WatchlistDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function watchlistsUpdateUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsUpdateMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsUpdate',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsUpdateMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, Types.WatchlistUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, Types.WatchlistUpdateDto, TContext> {
  const key = watchlistsUpdateMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.WatchlistUpdateDto) => Client.watchlistsUpdate(id, body),
    mutationKey: key,
  });
}
  
type WatchlistsUpdate__MutationParameters = WatchlistsUpdateWatchlistsQueryParameters & {
  body: Types.WatchlistUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsUpdateWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsUpdate__MutationParameters, TContext> {
  const key = watchlistsUpdateMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsUpdate__MutationParameters) => Client.watchlistsUpdate(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useWatchlistsDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = watchlistsDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.watchlistsDelete(id),
    mutationKey: key,
  });
}
  
type WatchlistsDelete__MutationParameters = WatchlistsDeleteWatchlistsQueryParameters

/**
 * @return OK
 */
export function useWatchlistsDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, WatchlistsDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsDeleteWatchlistsQueryParameters}): UseMutationResult<void, unknown, WatchlistsDelete__MutationParameters, TContext> {
  const key = watchlistsDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsDelete__MutationParameters) => Client.watchlistsDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function watchlistsSortUrl(watchlistId: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{watchlistId}/sort";
if (watchlistId === undefined || watchlistId === null)
  throw new Error("The parameter 'watchlistId' must be defined.");
url_ = url_.replace("{watchlistId}", encodeURIComponent("" + watchlistId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsSortMutationKey(watchlistId: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsSort',
      watchlistId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsSortMutation<TContext>(watchlistId: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, Types.PortfolioSortingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, Types.PortfolioSortingDto, TContext> {
  const key = watchlistsSortMutationKey(watchlistId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.PortfolioSortingDto) => Client.watchlistsSort(watchlistId, body),
    mutationKey: key,
  });
}
  
type WatchlistsSort__MutationParameters = WatchlistsSortWatchlistsQueryParameters & {
  body: Types.PortfolioSortingDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsSortMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsSort__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsSortWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsSort__MutationParameters, TContext> {
  const key = watchlistsSortMutationKey(options?.parameters?.watchlistId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsSort__MutationParameters) => Client.watchlistsSort(data.watchlistId ?? options?.parameters?.watchlistId!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsCreateSectionUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/sections";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsCreateSectionMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsCreateSection',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsCreateSectionMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.SectionDto, unknown, Types.SectionCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SectionDto, unknown, Types.SectionCreateDto, TContext> {
  const key = watchlistsCreateSectionMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionCreateDto) => Client.watchlistsCreateSection(id, body),
    mutationKey: key,
  });
}
  
type WatchlistsCreateSection__MutationParameters = WatchlistsCreateSectionWatchlistsQueryParameters & {
  body: Types.SectionCreateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsCreateSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SectionDto, unknown, WatchlistsCreateSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsCreateSectionWatchlistsQueryParameters}): UseMutationResult<Types.SectionDto, unknown, WatchlistsCreateSection__MutationParameters, TContext> {
  const key = watchlistsCreateSectionMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsCreateSection__MutationParameters) => Client.watchlistsCreateSection(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsUpdateSectionUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/sections/{sectionId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsUpdateSectionMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsUpdateSection',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsUpdateSectionMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.SectionDto, unknown, Types.SectionUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SectionDto, unknown, Types.SectionUpdateDto, TContext> {
  const key = watchlistsUpdateSectionMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionUpdateDto) => Client.watchlistsUpdateSection(id, sectionId, body),
    mutationKey: key,
  });
}
  
type WatchlistsUpdateSection__MutationParameters = WatchlistsUpdateSectionWatchlistsQueryParameters & {
  body: Types.SectionUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsUpdateSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SectionDto, unknown, WatchlistsUpdateSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsUpdateSectionWatchlistsQueryParameters}): UseMutationResult<Types.SectionDto, unknown, WatchlistsUpdateSection__MutationParameters, TContext> {
  const key = watchlistsUpdateSectionMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsUpdateSection__MutationParameters) => Client.watchlistsUpdateSection(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsDeleteSectionUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/sections/{sectionId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsDeleteSectionMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsDeleteSection',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @return OK
 */
export function useWatchlistsDeleteSectionMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, void, TContext> {
  const key = watchlistsDeleteSectionMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.watchlistsDeleteSection(id, sectionId),
    mutationKey: key,
  });
}
  
type WatchlistsDeleteSection__MutationParameters = WatchlistsDeleteSectionWatchlistsQueryParameters

/**
 * @return OK
 */
export function useWatchlistsDeleteSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsDeleteSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsDeleteSectionWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsDeleteSection__MutationParameters, TContext> {
  const key = watchlistsDeleteSectionMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsDeleteSection__MutationParameters) => Client.watchlistsDeleteSection(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!),
  mutationKey: key,
});
}
  
export function watchlistsSortSectionUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/sections/{sectionId}/sort";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsSortSectionMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsSortSection',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsSortSectionMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, Types.SectionSortingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, Types.SectionSortingDto, TContext> {
  const key = watchlistsSortSectionMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionSortingDto) => Client.watchlistsSortSection(id, sectionId, body),
    mutationKey: key,
  });
}
  
type WatchlistsSortSection__MutationParameters = WatchlistsSortSectionWatchlistsQueryParameters & {
  body: Types.SectionSortingDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsSortSectionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsSortSection__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsSortSectionWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsSortSection__MutationParameters, TContext> {
  const key = watchlistsSortSectionMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsSortSection__MutationParameters) => Client.watchlistsSortSection(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsMoveAssetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/move-asset";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsMoveAssetMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsMoveAsset',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsMoveAssetMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, Types.MoveAssetDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, Types.MoveAssetDto, TContext> {
  const key = watchlistsMoveAssetMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.MoveAssetDto) => Client.watchlistsMoveAsset(id, body),
    mutationKey: key,
  });
}
  
type WatchlistsMoveAsset__MutationParameters = WatchlistsMoveAssetWatchlistsQueryParameters & {
  body: Types.MoveAssetDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsMoveAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsMoveAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsMoveAssetWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsMoveAsset__MutationParameters, TContext> {
  const key = watchlistsMoveAssetMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsMoveAsset__MutationParameters) => Client.watchlistsMoveAsset(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsGetSectionLookupUrl(watchlistIds?: string[] | undefined): string {
  let url_ = getBaseUrl() + "/api/watchlists/sections/lookup?";
if (watchlistIds === null)
    throw new Error("The parameter 'watchlistIds' cannot be null.");
else if (watchlistIds !== undefined)
    watchlistIds && watchlistIds.forEach(item => { url_ += "watchlistIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let watchlistsGetSectionLookupDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, unknown, Types.ListResultDtoOfSectionLookupDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, unknown, Types.ListResultDtoOfSectionLookupDto>, 'queryFn'>> = {
};
export function getWatchlistsGetSectionLookupDefaultOptions() {
  return watchlistsGetSectionLookupDefaultOptions;
};
export function setWatchlistsGetSectionLookupDefaultOptions(options: typeof watchlistsGetSectionLookupDefaultOptions) {
  watchlistsGetSectionLookupDefaultOptions = options;
}

export function watchlistsGetSectionLookupQueryKey(watchlistIds?: string[] | undefined): QueryKey;
export function watchlistsGetSectionLookupQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { watchlistIds,  } = params[0] as WatchlistsGetSectionLookupWatchlistsQueryParameters;

    return trimArrayEnd([
        'WatchlistsClient',
        'watchlistsGetSectionLookup',
        watchlistIds as any,
      ]);
  } else {
    return trimArrayEnd([
        'WatchlistsClient',
        'watchlistsGetSectionLookup',
        ...params
      ]);
  }
}
export function __watchlistsGetSectionLookup(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.watchlistsGetSectionLookup(
      context.queryKey[2] as string[] | undefined,axiosConfig    );
}

export function useWatchlistsGetSectionLookupQuery<TSelectData = Types.ListResultDtoOfSectionLookupDto, TError = unknown>(dto: WatchlistsGetSectionLookupWatchlistsQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param watchlistIds (optional) 
 * @return OK
 */
export function useWatchlistsGetSectionLookupQuery<TSelectData = Types.ListResultDtoOfSectionLookupDto, TError = unknown>(watchlistIds?: string[] | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useWatchlistsGetSectionLookupQuery<TSelectData = Types.ListResultDtoOfSectionLookupDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let watchlistIds: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ watchlistIds,  } = params[0] as WatchlistsGetSectionLookupWatchlistsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [watchlistIds, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __watchlistsGetSectionLookup(context, axiosConfig) : __watchlistsGetSectionLookup,
    queryKey: watchlistsGetSectionLookupQueryKey(watchlistIds),
    ...watchlistsGetSectionLookupDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfSectionLookupDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param watchlistIds (optional) 
 * @return OK
 */
export function setWatchlistsGetSectionLookupData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfSectionLookupDto | undefined) => Types.ListResultDtoOfSectionLookupDto, watchlistIds?: string[] | undefined) {
  queryClient.setQueryData(watchlistsGetSectionLookupQueryKey(watchlistIds),
    updater
  );
}

/**
 * @param watchlistIds (optional) 
 * @return OK
 */
export function setWatchlistsGetSectionLookupDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfSectionLookupDto | undefined) => Types.ListResultDtoOfSectionLookupDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function watchlistsAddAssetUrl(id: string, sectionId: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/sections/{sectionId}/assets";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsAddAssetMutationKey(id: string, sectionId: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsAddAsset',
      id as any,
      sectionId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsAddAssetMutation<TContext>(id: string, sectionId: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, Types.SectionAssetCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, Types.SectionAssetCreateDto, TContext> {
  const key = watchlistsAddAssetMutationKey(id, sectionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionAssetCreateDto) => Client.watchlistsAddAsset(id, sectionId, body),
    mutationKey: key,
  });
}
  
type WatchlistsAddAsset__MutationParameters = WatchlistsAddAssetWatchlistsQueryParameters & {
  body: Types.SectionAssetCreateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsAddAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsAddAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsAddAssetWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsAddAsset__MutationParameters, TContext> {
  const key = watchlistsAddAssetMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsAddAsset__MutationParameters) => Client.watchlistsAddAsset(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsUpdateAssetUrl(id: string, sectionId: string, assetId: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/sections/{sectionId}/assets/{assetId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
if (assetId === undefined || assetId === null)
  throw new Error("The parameter 'assetId' must be defined.");
url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsUpdateAssetMutationKey(id: string, sectionId: string, assetId: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsUpdateAsset',
      id as any,
      sectionId as any,
      assetId as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsUpdateAssetMutation<TContext>(id: string, sectionId: string, assetId: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, Types.SectionAssetUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, Types.SectionAssetUpdateDto, TContext> {
  const key = watchlistsUpdateAssetMutationKey(id, sectionId, assetId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SectionAssetUpdateDto) => Client.watchlistsUpdateAsset(id, sectionId, assetId, body),
    mutationKey: key,
  });
}
  
type WatchlistsUpdateAsset__MutationParameters = WatchlistsUpdateAssetWatchlistsQueryParameters & {
  body: Types.SectionAssetUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useWatchlistsUpdateAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsUpdateAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsUpdateAssetWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsUpdateAsset__MutationParameters, TContext> {
  const key = watchlistsUpdateAssetMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!, options?.parameters?.assetId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsUpdateAsset__MutationParameters) => Client.watchlistsUpdateAsset(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.assetId ?? options?.parameters?.assetId!, data.body),
  mutationKey: key,
});
}
  
export function watchlistsDeleteAssetUrl(id: string, sectionId: string, assetId: string): string {
  let url_ = getBaseUrl() + "/api/watchlists/{id}/sections/{sectionId}/assets/{assetId}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (sectionId === undefined || sectionId === null)
  throw new Error("The parameter 'sectionId' must be defined.");
url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
if (assetId === undefined || assetId === null)
  throw new Error("The parameter 'assetId' must be defined.");
url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function watchlistsDeleteAssetMutationKey(id: string, sectionId: string, assetId: string): MutationKey {
  return trimArrayEnd([
      'WatchlistsClient',
      'watchlistsDeleteAsset',
      id as any,
      sectionId as any,
      assetId as any,
    ]);
}

/**
 * @return OK
 */
export function useWatchlistsDeleteAssetMutation<TContext>(id: string, sectionId: string, assetId: string, options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.WatchlistDto, unknown, void, TContext> {
  const key = watchlistsDeleteAssetMutationKey(id, sectionId, assetId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.watchlistsDeleteAsset(id, sectionId, assetId),
    mutationKey: key,
  });
}
  
type WatchlistsDeleteAsset__MutationParameters = WatchlistsDeleteAssetWatchlistsQueryParameters

/**
 * @return OK
 */
export function useWatchlistsDeleteAssetMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.WatchlistDto, unknown, WatchlistsDeleteAsset__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: WatchlistsDeleteAssetWatchlistsQueryParameters}): UseMutationResult<Types.WatchlistDto, unknown, WatchlistsDeleteAsset__MutationParameters, TContext> {
  const key = watchlistsDeleteAssetMutationKey(options?.parameters?.id!, options?.parameters?.sectionId!, options?.parameters?.assetId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: WatchlistsDeleteAsset__MutationParameters) => Client.watchlistsDeleteAsset(data.id ?? options?.parameters?.id!, data.sectionId ?? options?.parameters?.sectionId!, data.assetId ?? options?.parameters?.assetId!),
  mutationKey: key,
});
}